export * as ACCTRANS from './ACCTRANS.svg'
export * as ACCTRANS_stroke from './ACCTRANS_stroke.svg'
export * as ANTICORR from './ANTICORR.svg'
export * as ANTICORR_stroke from './ANTICORR_stroke.svg'
export * as BUSENV from './BUSENV.svg'
export * as BUSENV_stroke from './BUSENV_stroke.svg'
export * as CITVOICE from './CITVOICE.svg'
export * as EDUC from './EDUC.svg'
export * as EDUC_stroke from './EDUC_stroke.svg'
export * as FEO from './FEO.svg'
export * as FEO_stroke from './FEO_stroke.svg'
export * as GEND from './GEND.svg'
export * as GEND_stroke from './GEND_stroke.svg'
export * as GOVERNANCE from './GOVERNANCE.svg'
export * as GOVERNANCE_stroke from './GOVERNANCE_stroke.svg'
export * as HD from './HD.svg'
export * as HD_stroke from './HD_stroke.svg'
export * as HEALTH from './HEALTH.svg'
export * as HEALTH_stroke from './HEALTH_stroke.svg'
export * as INCLEQ from './INCLEQ.svg'
export * as INCLEQ_stroke from './INCLEQ_stroke.svg'
export * as INFR from './INFR.svg'
export * as INFRA from './INFRA.svg'
export * as INFRA_stroke from './INFRA_stroke.svg'
export * as INFR_stroke from './INFR_stroke.svg'
export * as NATSEC from './NATSEC.svg'
export * as NATSEC_stroke from './NATSEC_stroke.svg'
export * as OG from './OG.svg'
export * as OG_stroke from './OG_stroke.svg'
export * as PART from './PART.svg'
export * as PARTICIP from './PARTICIP.svg'
export * as PARTICIP_stroke from './PARTICIP_stroke.svg'
export * as PART_stroke from './PART_stroke.svg'
export * as PERDSAF_stroke from './PERDSAF_stroke.svg'
export * as PERSAF from './PERSAF.svg'
export * as PHR from './PHR.svg'
export * as PHR_stroke from './PHR_stroke.svg'
export * as PRI from './PRI.svg'
export * as PRI_stroke from './PRI_stroke.svg'
export * as PUBADMIN from './PUBADMIN.svg'
export * as PUBADMIN_stroke from './PUBADMIN_stroke.svg'
export * as PUBMAN from './PUBMAN.svg'
export * as PUBMAN_stroke from './PUBMAN_stroke.svg'
export * as PubPercEOF from './PubPercEOF.svg'
export * as PubPercHD from './PubPercHD.svg'
export * as PubPercPRI from './PubPercPRI.svg'
export * as PubPercROLS from './PubPercROLS.svg'
export * as RIGHTS from './RIGHTS.svg'
export * as RIGHTS_stroke from './RIGHTS_stroke.svg'
export * as ROLAW from './ROLAW.svg'
export * as ROLAW_stroke from './ROLAW_stroke.svg'
export * as ROLJUS from './ROLJUS.svg'
export * as ROLJUS_stroke from './ROLJUS_stroke.svg'
export * as RURAL from './RURAL.svg'
export * as RURAL_stroke from './RURAL_stroke.svg'
export * as SECSAF from './SECSAF.svg'
export * as SECSAF_stroke from './SECSAF_stroke.svg'
export * as SEO from './SEO.svg'
export * as SEO_stroke from './SEO_stroke.svg'
export * as SOCPROT from './SOCPROT.svg'
export * as SOCPROT_stroke from './SOCPROT_stroke.svg'
export * as SROL from './SROL.svg'
export * as SROL_stroke from './SROL_stroke.svg'
export * as SUSENV from './SUSENV.svg'
export * as SUSENV_stroke from './SUSENV_stroke.svg'
export * as TRANSACC from './TRANSACC.svg'
export * as TRANSACC_stroke from './TRANSACC_stroke.svg'
export * as WELF from './WELF.svg'
export * as WELF_stroke from './WELF_stroke.svg'
export * as camera_icon from './camera_icon.svg'
export * as copy_icon_dark_1x from './copy_icon_dark_1x.svg'
export * as document_csv_icon_1x from './document_csv_icon_1x.svg'
export * as document_pdf_icon_1x from './document_pdf_icon_1x.svg'
export * as document_xls_icon_1x from './document_xls_icon_1x.svg'
export * as email_icon from './email_icon.svg'
export * as graph from './graph.svg'
export * as library_icon_1x from './library_icon_1x.svg'
export * as overview from './overview.svg'
export * as table from './table.svg'
export * as trend_aat_down from './trend_aat_down.svg'
export * as trend_aat_up from './trend_aat_up.svg'
export * as trend_aat_zero from './trend_aat_zero.svg'
export * as trend_down from './trend_down.svg'
export * as trend_up from './trend_up.svg'
export * as trend_zero from './trend_zero.svg'
export * as trends from './trends.svg'
export * as external_data from './external_data.svg'
